import { supabase } from '../lib/supabase';
import { Product } from '../types';

export const productService = {
  // 获取所有商品（包含品牌信息）
  async getProducts() {
    const { data, error } = await supabase
      .from('products')
      .select(`
        *,
        brand:brands(*)
      `)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data as Product[];
  },

  // 根据ID获取单个商品
  async getProductById(id: string) {
    const { data, error } = await supabase
      .from('products')
      .select(`
        *,
        brand:brands(*)
      `)
      .eq('id', id)
      .single();

    if (error) throw error;
    return data as Product;
  },

  // 创建商品
  async createProduct(product: Omit<Product, 'id' | 'created_at' | 'updated_at'>) {
    const { data, error } = await supabase
      .from('products')
      .insert([product])
      .select()
      .single();

    if (error) throw error;
    return data as Product;
  },

  // 更新商品
  async updateProduct(id: string, product: Partial<Product>) {
    const { data, error } = await supabase
      .from('products')
      .update(product)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data as Product;
  },

  // 删除商品
  async deleteProduct(id: string) {
    const { error } = await supabase
      .from('products')
      .delete()
      .eq('id', id);

    if (error) throw error;
  },

  // 根据品牌筛选商品
  async getProductsByBrand(brandId: string) {
    const { data, error } = await supabase
      .from('products')
      .select(`
        *,
        brand:brands(*)
      `)
      .eq('brand_id', brandId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data as Product[];
  },

  // 根据类型筛选商品
  async getProductsByType(type: string) {
    const { data, error } = await supabase
      .from('products')
      .select(`
        *,
        brand:brands(*)
      `)
      .eq('product_type', type)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data as Product[];
  }
};
